module.exports = __webpack_public_path__ + "static/College-8675eaa889223922b7903c155b7020cb.png";